import React, { useState } from 'react';
import './AboutContact.css';
import BookingModal from './BookingModal';

const AboutContact = ({ settings = {} }) => {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  
  const {
    sections = [
      {
        title: 'BESTELLEN & LIEFERN',
        content: `Delivery & Take-away verfügbar
- Lieferung ab CHF 500.00 (unter CHF 500.00 nur Take-away)
- Vorbestellung ab 11:25 Uhr möglich
- Online-Bestellung über EAT.ch

Bei Allergien oder Unverträglichkeiten: Bitte rufen Sie uns an unter 043 818 29 12`,
        icon: '🚚',
        highlight_text: 'Lieferung ab CHF 500',
        type: 'delivery'
      },
      {
        title: 'ÖFFNUNGSZEITEN',
        content: `Montag – Freitag: 11:30 – 14:00 Uhr & 17:00 – 23:30 Uhr
Samstag – Sonntag: 12:00 – 23:30 Uhr`,
        icon: '🕐',
        type: 'hours'
      },
      {
        title: 'EVENTS & FEIERN',
        content: `Sei es für einen Teamanlass, für das grosse Familien-Zusammentreffen oder Feiern im Freundeskreis – in geselliger Runde essen macht mehr Spass!

Für Reservationen erreichen Sie uns telefonisch oder über unser Online-Formular.`,
        icon: '🎉',
        type: 'events'
      },
      {
        title: 'KONTAKT',
        content: `Restaurant Damas Wipkingen
Kyburgstrasse 28
8037 Zürich

Telefon: 043 818 29 12`,
        icon: '📞',
        type: 'contact'
      }
    ],
    closing_message = 'أهلاً وسهلاً – Willkommen bei uns!',
    tagline = 'Restaurant Damas Wipkingen – Wo orientalische Gastfreundschaft auf Zürcher Gemütlichkeit trifft.',
    email = 'info@restaurantdamas.ch',
    website = 'www.restaurantdamas.ch', 
    instagram = '@damasrestaurantzurich',
    background_color = '#ffffff',
    text_color = '#333333',
    accent_color = '#4A90E2'
  } = settings;

  const formatPhoneNumber = (text) => {
    // Regex to find phone numbers (Swiss format)
    const phoneRegex = /(\b\d{3}\s\d{3}\s\d{2}\s\d{2}\b)/g;
    const parts = text.split(phoneRegex);
    
    return parts.map((part, index) => {
      if (phoneRegex.test(part)) {
        const cleanPhone = part.replace(/\s/g, '');
        return (
          <a 
            key={index} 
            href={`tel:+41${cleanPhone}`}
            className="about-contact__phone-link"
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };

  const formatContent = (content, type) => {
    const lines = content.split('\n');
    
    if (type === 'delivery') {
      return lines.map((line, index) => {
        if (line.startsWith('-')) {
          const formattedLine = formatPhoneNumber(line.substring(1).trim());
          return <li key={index} className="about-contact__list-item">{formattedLine}</li>;
        }
        const formattedLine = formatPhoneNumber(line);
        return <p key={index} className="about-contact__text">{formattedLine}</p>;
      });
    }
    
    if (type === 'contact') {
      return lines.map((line, index) => {
        // Handle address line - make clickable to Google Maps
        if (line.includes('Kyburgstrasse')) {
          return (
            <p key={index} className="about-contact__text">
              <a href="https://maps.app.goo.gl/cgXcn5kms6dvihMa9" target="_blank" rel="noopener noreferrer" className="about-contact__address-link">
                {line}
              </a>
            </p>
          );
        }
        
        // Handle email line
        if (line.includes('E-Mail:')) {
          const emailMatch = line.match(/E-Mail:\s*(.+)/);
          const emailAddress = emailMatch ? emailMatch[1].trim() : '';
          return (
            <p key={index} className="about-contact__text">
              E-Mail: <a href={`mailto:${emailAddress}`} className="about-contact__email-link">{emailAddress}</a>
            </p>
          );
        }
        
        // Handle website line
        if (line.includes('Website:')) {
          const websiteMatch = line.match(/Website:\s*(.+)/);
          const websiteUrl = websiteMatch ? websiteMatch[1].trim() : '';
          const fullUrl = websiteUrl.startsWith('http') ? websiteUrl : `https://${websiteUrl}`;
          return (
            <p key={index} className="about-contact__text">
              Website: <a href={fullUrl} target="_blank" rel="noopener noreferrer" className="about-contact__website-link">{websiteUrl}</a>
            </p>
          );
        }
        
        // Handle Instagram line
        if (line.includes('Instagram:')) {
          const instagramMatch = line.match(/Instagram:\s*(.+)/);
          const instagramHandle = instagramMatch ? instagramMatch[1].trim().replace('@', '') : '';
          return (
            <p key={index} className="about-contact__text">
              Instagram: <a href={`https://instagram.com/${instagramHandle}`} target="_blank" rel="noopener noreferrer" className="about-contact__instagram-link">@{instagramHandle}</a>
            </p>
          );
        }
        
        const formattedLine = formatPhoneNumber(line);
        return <p key={index} className="about-contact__text">{formattedLine}</p>;
      });
    }
    
    return lines.map((line, index) => {
      const formattedLine = formatPhoneNumber(line);
      return <p key={index} className="about-contact__text">{formattedLine}</p>;
    });
  };

  const renderContactLinks = () => {
    return (
      <div className="about-contact__contact-links">
        <p className="about-contact__text">
          E-Mail: <a href={`mailto:${email}`} className="about-contact__email-link">{email}</a>
        </p>
        <p className="about-contact__text">
          Website: <a href={`https://${website}`} target="_blank" rel="noopener noreferrer" className="about-contact__website-link">{website}</a>
        </p>
        <p className="about-contact__text">
          Instagram: <a href={`https://instagram.com/${instagram.replace('@', '')}`} target="_blank" rel="noopener noreferrer" className="about-contact__instagram-link">{instagram}</a>
        </p>
      </div>
    );
  };

  return (
    <section className="about-contact" style={{ backgroundColor: background_color, color: text_color }}>
      <div className="about-contact__container">
        <div className="about-contact__grid">
          {sections.map((section, index) => (
            <div key={index} className={`about-contact__section about-contact__section--${section.type}`}>
              <div className="about-contact__section-header">
                <div className="about-contact__section-icon" style={{ backgroundColor: accent_color }}>
                  {section.icon}
                </div>
                <h3 className="about-contact__section-title" style={{ color: accent_color }}>
                  {section.title}
                </h3>
              </div>
              
              <div className="about-contact__section-content">
                {section.type === 'delivery' && (
                  <a href="/pages/takeaway" className="about-contact__highlight about-contact__highlight--clickable" style={{ backgroundColor: accent_color }}>
                    {section.highlight_text}
                  </a>
                )}
                
                {section.type === 'events' && (
                  <button 
                    onClick={() => setIsBookingModalOpen(true)}
                    className="about-contact__highlight about-contact__highlight--clickable" 
                    style={{ backgroundColor: accent_color }}
                  >
                    {section.highlight_text}
                  </button>
                )}
                
                <div className="about-contact__content">
                  {section.type === 'delivery' && section.content.includes('-') ? (
                    <ul className="about-contact__list">
                      {formatContent(section.content, section.type)}
                    </ul>
                  ) : (
                    formatContent(section.content, section.type)
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="about-contact__footer">
          <p className="about-contact__closing" style={{ color: accent_color }}>
            {closing_message}
          </p>
          <p className="about-contact__tagline">
            {tagline}
          </p>
        </div>
      </div>
      
      <BookingModal 
        isOpen={isBookingModalOpen} 
        onClose={() => setIsBookingModalOpen(false)} 
      />
    </section>
  );
};

export default AboutContact;